




















































import { Component } from "vue-property-decorator";
import Modal from "@/shared/components/modal.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import { LeadService, Lead, EditarLeadCommand } from "@/services/lead.service";
import ComboTipoLead from "../components/ComboTipoLead.vue";
import ComboCanalLead from "../components/ComboCanalLead.vue";
import ComboResponsavelLead from "../components/ComboResponsavelLead.vue";
import { required } from "@/shared/validators";

@Component({
  components: { Modal, ComboTipoLead, ComboCanalLead, ComboResponsavelLead },
})
export default class AdicionarLead extends mixins(GlobalMixin) {
  loading = false;
  lead: EditarLeadCommand = {} as EditarLeadCommand;
  idLead: number | null = null;

  rules = {
    nome: [required()],
    canalProspeccao: [required()],
    idTipoLead: [required()],
  };

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async editarLead(lead: Lead) {
    this.lead = {
      email: lead.email,
      idCanalLead: lead.idCanalLead,
      idTipoLead: lead.idTipoLead,
      idUsuario: lead.idUsuario,
      nome: lead.nome,
      trabalho: lead.trabalho,
    };

    this.idLead = lead.idLead;

    const modal = this.$refs.modal as Modal;
    const p = modal.open();

    return p;
  }

  async salvarAlteracoes() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    if (form.validate()) {
      this.loading = true;
      try {
        if (this.lead) {
          await LeadService.editarLead(this.idLead!, this.lead);
        }
        modal.close(true);
      } finally {
        this.loading = false;
      }
    }
  }
}
